<svg width="140" height="90" viewBox="0 0 140 90" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="139" height="88.7739" rx="3.5" fill="currentColor" stroke="#BBBFC3"/>
    <rect x="5" y="59.9163" width="17.2832" height="11.5771" rx="2" fill="#BBBFC3"/>
    <rect x="5" y="47" width="17.2832" height="11.5771" rx="2" fill="#BBBFC3"/>
    <rect x="23.7891" y="59.9163" width="17.2832" height="11.5771" rx="2" fill="#BBBFC3"/>
    <rect x="23.7891" y="47" width="17.2832" height="11.5771" rx="2" fill="#BBBFC3"/>
    <rect x="42.5703" y="59.9163" width="17.2832" height="11.5771" rx="2" fill="#BBBFC3"/>
    <rect x="42.5703" y="47" width="17.2832" height="11.5771" rx="2" fill="#BBBFC3"/>
    <rect x="61.3594" y="59.9163" width="17.2832" height="11.5771" rx="2" fill="#BBBFC3"/>
    <rect x="61.3594" y="47" width="17.2832" height="11.5771" rx="2" fill="#BBBFC3"/>
    <rect x="98.9297" y="59.9163" width="17.2832" height="11.5771" rx="2" fill="#BBBFC3"/>
    <rect x="98.9297" y="47" width="17.2832" height="11.5771" rx="2" fill="#BBBFC3"/>
    <rect x="80.1484" y="59.9163" width="17.2832" height="11.5771" rx="2" fill="#BBBFC3"/>
    <rect x="80.1484" y="47" width="17.2832" height="11.5771" rx="2" fill="#BBBFC3"/>
    <rect x="117.719" y="59.9163" width="17.2832" height="11.5771" rx="2" fill="#BBBFC3"/>
    <rect x="117.719" y="47" width="17.2832" height="11.5771" rx="2" fill="#BBBFC3"/>
    <rect x="5" y="73.4229" width="17.2832" height="11.5771" rx="2" fill="#BBBFC3"/>
    <rect x="23.7891" y="73.4229" width="17.2832" height="11.5771" rx="2" fill="#BBBFC3"/>
    <rect x="42.5703" y="73.4229" width="17.2832" height="11.5771" rx="2" fill="#BBBFC3"/>
    <rect x="61.3594" y="73.4229" width="17.2832" height="11.5771" rx="2" fill="#BBBFC3"/>
    <rect x="98.9297" y="73.4229" width="17.2832" height="11.5771" rx="2" fill="#BBBFC3"/>
    <rect x="80.1484" y="73.4229" width="17.2832" height="11.5771" rx="2" fill="#BBBFC3"/>
    <rect x="117.719" y="73.4229" width="17.2832" height="11.5771" rx="2" fill="#BBBFC3"/>
    <rect x="37" y="5" width="66" height="38" rx="2" fill="#BBBFC3"/>
</svg>
